var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.125 6.125H7.875V0.875C7.875 0.35 7.525 0 7 0C6.475 0 6.125 0.35 6.125 0.875V6.125H0.875C0.35 6.125 0 6.475 0 7C0 7.525 0.35 7.875 0.875 7.875H6.125V13.125C6.125 13.65 6.475 14 7 14C7.525 14 7.875 13.65 7.875 13.125V7.875H13.125C13.65 7.875 14 7.525 14 7C14 6.475 13.65 6.125 13.125 6.125Z",
    fill: "#C7D2FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaPlus);
export default __webpack_public_path__ + "static/media/FaPlus.0b55f2ef4eec6b0eb31aa1b870cf5f0d.svg";
export { ForwardRef as ReactComponent };